<template>
  <div v-if="show" class="fixed pin z-50 overflow-auto bg-smoke-light flex">
    <on-click-outside v-if="show" :do="() => close">
      <div
        class="relative rounded-lg shadow-lg bg-white w-full m-auto flex-col flex"
        :class="maxWidthClass"
      >
        <span class="absolute pin-t pin-r p-4" @click="close">
          <svg
            class="h-4 w-4 text-grey-lighter hover:text-grey-darkest"
            role="button"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <title>Close</title>
            <path
              d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
            />
          </svg>
        </span>
        <div class="bg-grey-lightest p-3 rounded-t text-grey-darkest">
          <slot name="header">
            <h3 class="p-3 modal-title">Modal title</h3>
          </slot>
        </div>
        <div class="p-3">
          <slot name="body">
            <p>Modal body text goes here.</p>
          </slot>
        </div>

        <div class="bg-grey-lighter rounded-b-lg p-3 flex justify-end">
          <slot name="footer" class="flex justify-between">
            <button
              type="button"
              class="text-white p-2 bg-blue font-semibold rounded-lg"
            >
              Save changes
            </button>
          </slot>
        </div>
      </div>
    </on-click-outside>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    large: Boolean,
    width: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    maxWidthClass() {
      return {
        ['max-w-' + this.width]: true
      };
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>



// WEBPACK FOOTER //
// Modal.vue?46aa92e9